<template>
  <div>
    <section id="firebaseui-auth-container"></section>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default {
  name: "Admin",
  data: () => ({
    user: null,
  }),
  components: {},
  methods: {},
  mounted() {
    let ui = firebaseui.auth.AuthUI.getInstance();

    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    var uiConfig = {
      signInSuccessUrl: "/modsEdit",
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          disableSignUp: {
            status: true,
            adminEmail: "gabriel_costa25@hotmail.com",
            helpLink: "/",
          },
        },
      ],
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  computed: {},
};
</script>
